import { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import AccountService from "../../../../services/accounts.service";
import { Breadcrumb, Button, Card, Tabs, Tooltip } from "antd";
import { BiInfoCircle } from "react-icons/bi";
import Loader from "../../../../components/loader";
import { AiOutlineLeft } from "react-icons/ai";
import { amountFormat } from "../../../../services/common.service";
import { useTranslation } from "react-i18next";

export default function ShowAccountBalances() {
  const navigate = useNavigate();
  const location = useLocation();
  const [accountDetails, setAccountDetails] = useState({});
  const [dataSource, setDataSource] = useState([]);
  const [noRecords, setNoRecords] = useState(false);
  const [loader, setLoader] = useState(false);
  const [activeKey, setActiveKey] = useState("ACCOUNT_DETAILS");
  const { t } = useTranslation();
  useEffect(() => {
    if (location.state) {
      setAccountDetails(location.state);
      getBalanceEnquiry(location.state);
    }
  }, []);

  // const handleTabClick = (key) => {
  //   setActiveKey(key);
  //   if (key === "ACCOUNT_DETAILS") {
  //     navigate("/accounts/summary", { state: accountDetails });
  //   }
  //   if (key === "MINI_STATEMENT") {
  //     navigate("/accounts/statement", { state: accountDetails });
  //   }
  //   if (key === "E_STATEMENT") {
  //     navigate("/accounts/statement/eStatement", {
  //       state: accountDetails,
  //     });
  //   }
  //   if (key === "DETAILED_STATEMENT") {
  //     navigate("/accounts/statement/detailed", {
  //       state: accountDetails,
  //     });
  //   }
  // };

  const getBalanceEnquiry = useCallback(async (details) => {
    try {
      setLoader(true);
      const response = await AccountService.getBalanceEnquiry({
        accountNo: details?.accountNo,
        branchId: details?.branchId,
      });

      if (response.status === 200) {
        setLoader(false);
        setDataSource(response.data);
      }
    } catch (error) {
      setLoader(false);
    }
  }, []);

  return (
    <>
       {/* 
       
        <Breadcrumb separator=">">
          <Breadcrumb.Item>
            <span onClick={() => navigate("/dashboard")}>
              <HomeIcon height={14}/>
            </span>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span onClick={() => navigate("/accounts")}>
              {t("navigation.account", {
                defaultValue: "Accounts",
              })}
            </span>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span>
              {t("buttons.View Balances", {
                defaultValue: "View Balances",
              })}
            </span>
          </Breadcrumb.Item>
        </Breadcrumb>
    
      <Card size="small" className="mb-1 text-center breadcrumb-title-card">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-left align-items-center heading mx-0">
            {/* <TitleIcon height={30} style={{ marginLeft: "-20px" }} /> }
            <h3 className="title mb-0">
              {t("buttons.View Balances", {
                defaultValue: "View Balances",
              })}
            </h3>
          </div>
        </div>
      </Card>

      <Card className="account-tab-card mb-1">
        <Tabs
          defaultActiveKey="1"
          type="line"
          onChange={setActiveKey}
          activeKey={activeKey}
          onTabClick={handleTabClick}
        >
          <Tabs.TabPane
            tab={t("pages.gepeg.account_details", {
              defaultValue: "Account Details",
            })}
            key="ACCOUNT_DETAILS"
          ></Tabs.TabPane>
          <Tabs.TabPane
            tab={t("pages.gepeg.view_balances", {
              defaultValue: "View Balances",
            })}
            key="VIEW_BALANCES"
          ></Tabs.TabPane>
          <Tabs.TabPane
            tab={t("navigation.statement", {
              defaultValue: "Statement",
            })}
            key="MINI_STATEMENT"
          ></Tabs.TabPane>
          <Tabs.TabPane
            tab={t("buttons.detailed_stmt_btn", {
              defaultValue: "Detailed Statement",
            })}
            key="DETAILED_STATEMENT"
          ></Tabs.TabPane>
          <Tabs.TabPane
            tab={t("pages.my_accounts.casa.eStatement_Request", {
                      defaultValue: "eStatement Request",
                    })}
            key="E_STATEMENT"
          ></Tabs.TabPane>
        </Tabs>
      </Card> */}

      <div className="row account-balances">
        <div className="col-xs-12 col-sm-12 col-md-11 col-lg-11 col-xl-11 ">
        

          <Card className="mb-3 application-card">
            <div className="d-flex justify-content-between align-items-center">
              <h5 style={{ margin: 0 }}>
                {accountDetails?.accountName} - {accountDetails?.accountType}{" "}
                {accountDetails?.accountNo}
              </h5>
            </div>
          </Card>

          {loader && (
            <div>
              <Loader />
            </div>
          )}

          <div className="row ">
            {dataSource.map((option, idx) => (
              <div className="col-12 col-sm-6 col-md-12 col-lg-3" key={idx}>
                <Card
                  title={
                    <Tooltip placement="top" title={option?.balTypeIContent}>
                      <div
                        className="d-flex justify-content-center align-items-center"
                        style={{ cursor: "pointer", position: "relative" }}
                        align="center"
                      >
                        <span>{option?.balTypeDesc}</span>
                        <BiInfoCircle
                          className="aqua"
                          size={18}
                          style={{ position: "absolute", right: 0 }}
                        />
                      </div>
                    </Tooltip>
                  }
                  className="mt-3 application-card"
                >
                  <h6 style={{ textAlign: "center" }}>
                    {amountFormat(option?.balAmtValue)}
                  </h6>
                </Card>
              </div>
            ))}
          </div>
          {dataSource.length > 0 && (
            <div className="mt-5">
              <p>
                <b>
                  {t("common.note", {
                    defaultValue: "Note",
                  })}
                  :
                </b>
              </p>
              <p>
                {t("pages.my_accounts.casa.authorisation_txt", {
                  defaultValue:
                    "Balance would get updated in few transactions, only after authorisation by bank staff",
                })}
              </p>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
